import { collection, doc, getDoc, getDocs, query, setDoc, where } from 'firebase/firestore';
import { getRegionByCity } from './regionUtils';

export const normalizeMarketName = (value) => String(value || '')
    .normalize('NFKC')
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('zh-TW');

export const getMarketRegion = (market) => {
    if (!market) return null;
    return getRegionByCity(String(market.city || '').trim()) || market.region || null;
};

export const findDuplicateMarket = (markets, city, name, excludeId = '') => {
    const normalizedCity = String(city || '').trim();
    const normalizedName = normalizeMarketName(name);
    return (markets || []).find(market =>
        market.id !== excludeId &&
        String(market.city || '').trim() === normalizedCity &&
        normalizeMarketName(market.name) === normalizedName
    ) || null;
};

const getDeterministicMarketId = (city, name) =>
    `market__${encodeURIComponent(`${String(city).trim()}|${normalizeMarketName(name)}`)}`;

export const findDuplicateMarketInFirestore = async (db, appId, city, name, excludeId = '') => {
    const normalizedCity = String(city || '').trim();
    const snapshot = await getDocs(query(
        collection(db, `artifacts/${appId}/public/data/markets`),
        where('city', '==', normalizedCity)
    ));
    return snapshot.docs
        .map(item => ({ id: item.id, ...item.data() }))
        .find(market => market.id !== excludeId && normalizeMarketName(market.name) === normalizeMarketName(name)) || null;
};

export const createUniqueMarket = async ({ db, appId, markets, marketData }) => {
    const city = String(marketData.city || '').trim();
    const name = String(marketData.name || '').normalize('NFKC').trim().replace(/\s+/g, ' ');
    const localDuplicate = findDuplicateMarket(markets, city, name);
    if (localDuplicate) return { created: false, market: localDuplicate };

    const serverDuplicate = await findDuplicateMarketInFirestore(db, appId, city, name);
    if (serverDuplicate) return { created: false, market: serverDuplicate };

    // 同一個「縣市＋正規化名稱」永遠寫到同一文件 ID；即使兩人同時新增，也不會產生兩筆。
    const marketRef = doc(db, `artifacts/${appId}/public/data/markets`, getDeterministicMarketId(city, name));
    const existing = await getDoc(marketRef);
    if (existing.exists()) return { created: false, market: { id: existing.id, ...existing.data() } };

    const data = { ...marketData, city, name };
    await setDoc(marketRef, data);
    return { created: true, market: { id: marketRef.id, ...data } };
};
